import React from 'react';
import { Box, Paper } from '@mui/material';
import PagePrint from './PagePrint';

const LeftArrowIcon = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/Images/CommonImages/GoLeft.png';


const PIActionBar = ({ onBack, printRef, printName }) => {
  return (
    <Paper
      sx={{
        width: '95%',
        mx: 'auto',
        height: '50px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignContent: 'center',
      }}
      elevation={0}
    >
      <Box
        component="img"
        src={LeftArrowIcon}
        sx={{ width: '25px', cursor: 'pointer' }}
        onClick={onBack}
      />
      <Box
        sx={{
          display: 'flex',
          width: '60px',
          justifyContent: 'space-between',
        }}
      >
        <PagePrint pageref={printRef} name={printName} />
      </Box>
    </Paper>
  );
};

export default PIActionBar;


